import { Box } from '@mui/material';
import { Typography, colors } from '@sweep-io/sweep-design';

const AgentTypeTag = ({
  size,
  color,
  text,
}: {
  size: 'small' | 'big';
  color: string;
  text: string;
}) => {
  const isSmall = size === 'small';
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        borderRadius: '2px',
        width: 'fit-content',
        paddingInline: isSmall ? '4px' : '8px',
        height: isSmall ? '22px' : '30px',
        backgroundColor: color,
      }}
    >
      <Typography
        variant={isSmall ? 'caption' : 'body'}
        color={isSmall ? colors.grey[700] : colors.grey[900]}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default AgentTypeTag;
